// Rotas de autenticação que NÃO participam da lógica de refresh em 401: o 401 delas
// é resposta de negócio (credenciais/ticket), não token de sessão vencido.
export const SESSIONLESS_AUTH_URLS = ['/auth/login/', '/auth/login/verify/', '/auth/login/resend/']

export const isSessionlessAuthUrl = url => SESSIONLESS_AUTH_URLS.includes(url)
